enum HeaderMenuActionTypes {
  Users = 'Users',
  Roles = 'Roles',
  Profile = 'Profile',
  ArtistProfile = 'ArtistProfile',
  LogOut = 'LogOut',
}

export default HeaderMenuActionTypes;
